import { IconProps } from '../../../icons/icon-props-interface';

const IconAnalytics: React.FC<IconProps> = ({ color = 'var(--color-primary-2)' }: IconProps): JSX.Element => (

<svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1563_3285)">
<path d="M8.5 5.5C8.5 4.67188 9.17188 4 10 4H11C11.8281 4 12.5 4.67188 12.5 5.5V16.5C12.5 17.3281 11.8281 18 11 18H10C9.17188 18 8.5 17.3281 8.5 16.5V5.5ZM3.5 11.5C3.5 10.6719 4.17188 10 5 10H6C6.82812 10 7.5 10.6719 7.5 11.5V16.5C7.5 17.3281 6.82812 18 6 18H5C4.17188 18 3.5 17.3281 3.5 16.5V11.5ZM15 6H16C16.8281 6 17.5 6.67188 17.5 7.5V16.5C17.5 17.3281 16.8281 18 16 18H15C14.1719 18 13.5 17.3281 13.5 16.5V7.5C13.5 6.67188 14.1719 6 15 6Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0_1563_3285">
<rect width="14" height="16" fill="white" transform="translate(3.5 3)"/>
</clipPath>
</defs>
</svg>



);



export default IconAnalytics;